import { getEmail, getFullName } from 'actions/auth/login';
import { createSelector } from 'reselect';

export const getFeedbackOpen = (state) => state.feedback.modalOpen;
export const getTopicDropdownOpen = (state) => state.feedback.topicDropdownOpen;
export const getTopic = (state) => state.feedback.topic;
export const getBody = (state) => state.feedback.body;

export const getFeedbackMessage = createSelector(
  [getFullName, getEmail, getTopic, getBody],
  (name, return_email, topic, body) => {
    if (!body || !name || !return_email || topic === 'Select')
      throw Error('Please check all fields');
    return {
      name,
      //TODO: make this optional so i can remove it
      phone: 'NO-PHONE-NUMBER',
      return_email,
      body: `${topic} - ${body}`
    };
  }
);



// WEBPACK FOOTER //
// ./src/actions/communication/feedback/feedbackSelectors.js